import { Popover } from '@base-ui/react/popover';
import { Icon } from '@petsmart-ui/sparky';
import { type RefObject } from 'react';

import { AccountButton } from '../../../account-button';
import { splitTriggerProps } from './split-trigger-props';

type TriggerRender = Extract<Popover.Trigger.Props['render'], (...args: never[]) => unknown>;

type TriggerProps = {
    accountHref: string;
    isDesktop: boolean;
    onTriggerClick?: () => void;
    onClose: () => void;
    onKeyboardOpen: () => void;
    openedWithKeyboard: boolean;
    props: Parameters<TriggerRender>[0];
    state: Parameters<TriggerRender>[1];
    toggleRef: RefObject<HTMLButtonElement | null>;
};

export function Trigger({
    accountHref,
    isDesktop,
    onTriggerClick,
    onClose,
    onKeyboardOpen,
    openedWithKeyboard,
    props,
    state,
    toggleRef,
}: Readonly<TriggerProps>) {
    const { buttonProps, groupProps } = splitTriggerProps({
        isOpen: state.open,
        onClose,
        onKeyboardOpen,
        openOnArrowDown: isDesktop,
        props,
        toggleRef,
    });

    if (!isDesktop) {
        return (
            <div {...groupProps} className="account-popover__control">
                <AccountButton {...buttonProps} />
            </div>
        );
    }

    return (
        <div
            {...groupProps}
            className="account-popover__control"
            data-pointer-open={state.open && !openedWithKeyboard ? '' : undefined}
        >
            <a href={accountHref} className="account-popover__link" aria-label="Account" onClick={onTriggerClick}>
                <Icon name="account-circle-outline" size="lg" aria-hidden="true" />
            </a>
            <button
                {...buttonProps}
                type="button"
                className="account-popover__toggle"
                data-keyboard-open={state.open && openedWithKeyboard ? '' : undefined}
            >
                <Icon name={state.open ? 'chevron-up' : 'chevron-down'} size="sm" aria-hidden="true" />
            </button>
        </div>
    );
}
